export default __webpack_public_path__ + "static/media/IBMPlexSans-Italic.a2a62bf6.woff";